import React from 'react'
import { Trans } from 'react-i18next'

type VideoHintProps = {
  requiredFieldsFilledIn: boolean
}

const VideoHint: React.FC<VideoHintProps> = ({ requiredFieldsFilledIn }) => {
  return requiredFieldsFilledIn ? (
    <Trans i18nKey='wizard.screen.multimediaNew.videoHint.enabled'>
      <strong>Please note:</strong> The documents must not contain any personal data (names, addresses, bank details) of
      third parties. A video (max. 1GB) can be uploaded once all mandatory fields have been filled in.
    </Trans>
  ) : (
    <Trans i18nKey='wizard.screen.multimediaNew.videoHint.disabled'>
      <strong>Please note:</strong> A video (max. 1GB) can be uploaded once all required fields are filled out
    </Trans>
  )
}

export default VideoHint
